import { createFileRoute } from "@tanstack/react-router";
import { ResetPasswordPage } from "../../features/auth/ResetPasswordPage";
import { linkTokenOf } from "../../search";

export const Route = createFileRoute("/auth/reset-password")({
  validateSearch: (search: Record<string, unknown>) => linkTokenOf(search, "recovery"),
  component: function ResetPassword() {
    return <ResetPasswordPage tokenHash={Route.useSearch().token_hash} />;
  },
});
